module.exports = __webpack_public_path__ + "museosans300-webfont.415697b5327a7956028e.woff";


//////////////////
// WEBPACK FOOTER
// D:/api-fronted/css/fonts/museosans300-webfont.woff
// module id = ../../../../../css/fonts/museosans300-webfont.woff
// module chunks = styles